<div class="import-uses-values-table-container">
    <div *ngIf="usesValuesValidationData$ | async as usesValuesValidationData">
        <zones-uses [currentTab]="'zones'" [uploadZoningCode]="false" [zoningCode]="usesValuesValidationData"
            [hideUseComponentsSelection]="true" [hideAttributeButtons]="true" [readOnly]="true"></zones-uses>
    </div>
</div>
<app-import-footer
    [templateType]="'ZONE_COMBINATION_USES_VALUES'"
    [showValidationIcon]="(usesValuesValidationData$ | async) !== null"
    [canImport]="canImport"
    [showValidateButton]="showValidateButton"
    (uploadFile)="openDialog()"
    (importData)="importData()"
    (validateZoningCode)="validateZC()"
    (clearTable)="clearUsesTable()"></app-import-footer>
